import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";


export const GetUserList = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/User/GetUserList`,
    params
  );
  return res;
};

export const GetUserPerformanceReport = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/User/GetUserPerformanceReport`,
    params
  );
  return res;
};

export const AddUpdateUser = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/User/AddUpdateUser`,
    params
  );
  return res;
};
export const GetUserModel = async (KeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/User/GetUserModel?UserKeyID=${KeyID}`
  );
  return res;
};

export const ChangeUserStatus = async (KeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/User/ChangeUserStatus?UserKeyID=${KeyID}`
  );
  return res;
};

export const DeleteUser = async (ModuleName, KeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/DeleteUser?ModuleName=${ModuleName}&UserKeyID=${KeyID}`
  );
  return res;
};

export const GetUserLookupList = async (id, moduleName) => {
  let url = moduleName ? `${Base_Url}/User/GetUserLookupList?RoleTypeID=${id}&ModuleName=${moduleName}` : `${Base_Url}/User/GetUserLookupList?RoleTypeID=${id}`
  const res = await getApiWithAuthorization(url);
  return res;
};

export const GetUserLookupListWithoutRoleType = async (id) => {
  const res = await getApiWithAuthorization(`${Base_Url}/User/GetUserLookupList`);
  return res;
};



export const GetUserLookupListAllocated = async (KeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/GetUserLookupList?UserKeyID=${KeyID}`
  );
  return res;
};

export const SetUserCheckIn = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/SetUserCheckIn`,
    params
  );
  return res;
};

export const SetUserCheckOut = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/SetUserCheckOut`,
    params
  );
  return res;
};

export const GetUserCheckInCheckOutStatus = async (UserKeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/GetUserCheckInCheckOutStatus?UserKeyID=${UserKeyID}`
  );
  return res;
};

export const GetAttendanceList = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/GetAttendanceList`,
    params
  );
  return res;
};

export const GetDailyReportModel = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/GetDailyReportModel`,
    params
  );
  return res;
};

export const UpdateUserProfile = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/UpdateUserProfile`,
    params
  );
  return res;
};
export const GetUserProfileModel = async (KeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/User/GetUserModel?UserKeyID=${KeyID}`
  );
  return res;
};

export const AddUpdateUserServiceMapping = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/AddUpdateUserServiceMapping`,
    params
  );
  return res;
};

export const GetUserMappedServices = async (UserKeyID, KeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/GetUserMappedServices?UserKeyID=${UserKeyID}&UserKeyIDForUpdate=${KeyID}`
  );
  return res;
};

export const GetJuniorUserLookupList = async (KeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/GetJuniorUserLookupList?UserKeyID=${KeyID}`
  );
  return res;
};


export const GetAllUserLookupList = async () => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/User/GetUserLookupList?RoleTypeID`
  );
  return res;
};

export const GetSiteEngineerLookupList = async (KeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/User/GetUserLookupList?RoleTypeID=${KeyID}`
  );
  return res;
};

export const GetTeamLeadLookupList = async (KeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/User/GetUserLookupList?RoleTypeID=${KeyID}`
  );
  return res;
};


export const GetProjectManagerLookupList = async (KeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/User/GetUserLookupList?RoleTypeID=${KeyID}`
  );
  return res;
};

export const GeStatusLookupList = async () => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/ProjectStatus/GetProjectStatusLookupList`
  );
  return res;
};

export const GetCityLookupList = async (stateID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/City/GetCityLookupList?StateID=${stateID}`
  );
  return res;
}


export const getUserDetails = async (UserKeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/User/GetUserDetails?UserKeyID=${UserKeyID}`
  );
  return res;
}

export const GetUserLookupListModulewise = async (moduleName, userKeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/User/GetUserLookupList?ModuleName=${moduleName}&UserKeyID=${userKeyID}`
  );
  return res;
};

export const GetUserVisitedLocations = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/User/GetUserTourMapList`,
    params
  );
  return res;
};